"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UIConfigSchema = void 0;
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.UIConfigSchema = tape_builder_base_1.LenderVerificationConfigSchema.omit({
    receivableResponseTapeArtifactSlug: true,
    borrowingBaseReportArtifactSlug: true,
});
exports.nodeType = 'operation_verify';
//# sourceMappingURL=types.js.map